const AVATARS_PATH = {};
for (let i = 1; i <= 13; i++) {
  AVATARS_PATH[i] = require('../assets/img/avatars/' + i + '.svg');
}

export default {
  STORE_EXT_URL: 'https://chrome.google.com/webstore/detail/kids-mode/bhgkffnlmkkimfbomibamhgoaecelckc',
  EXT_ID: 'bhgkffnlmkkimfbomibamhgoaecelckc',
  GUEST_PROFILE_ID: 'guestProfileSettings',
  API_URL: process.env.NODE_ENV === 'development' ? 'http://localhost:3124/api/' : 'https://kidsmode.net/api/',
  AVATARS_PATH,
  ACTIVE_CAMPAIGN: {
    LISTS: {
      EXTENSION_INSTALLED: 9,
      ANDROID_APP_INSTALLED: 10,
    },
    TAGS: {
      APP_INSTALL: 'appInstall',
      EXTENSION_INSTALL: 'extensionInstall',
      MONTH_SUBSCRIPTION: 'monthlySubscription',
      YEAR_SUBSCRIPTION: 'yearlySubscription',
    }
  },

  LINKED_ACCOUNT_STATUSES: {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected'
  },

  ACCOUNT_TYPES: {
    MAIN: 'main',
    LINKED: 'linked',
    REGULAR: 'regular'
  }
};